export const DisplayPnlEvent = {
  DisplayPnlSettingsClick: 'display_pnl_settings_click',
  DisplayPnlSettingsConfirmClick: 'display_pnl_settings_confirm_click',
} as const;

export interface DisplayPnlEventDataType {
  [DisplayPnlEvent.DisplayPnlSettingsConfirmClick]: {
    display_pnl_type: 'Unrealized P&L' | 'Net P&L';
  };
}
